import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BUILD_PROFILE } from 'utils/buildProfile';
import { shouldDisableTracking } from 'utils/env';

const MICROSOFT_UET_SCRIPT_ID = 'microsoft-uet-script';

const MicrosoftUetTag = () => {
  const location = useLocation();
  const uetTagId = (BUILD_PROFILE.microsoftUetTagId || '').trim();
  const shouldEnable = !!uetTagId && !shouldDisableTracking();

  useEffect(() => {
    if (!shouldEnable || typeof window === 'undefined' || typeof document === 'undefined') return;

    const queueName = 'uetq';
    (window as any)[queueName] = (window as any)[queueName] || [];

    if (document.getElementById(MICROSOFT_UET_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = MICROSOFT_UET_SCRIPT_ID;
    script.async = true;
    script.src = `https://bat.bing.net/bat.js?ti=${encodeURIComponent(uetTagId)}`;

    const onLoad = function onLoad(this: GlobalEventHandlers) {
      const state = (this as any).readyState;
      if (state && state !== 'loaded' && state !== 'complete') return;

      try {
        const queue = (window as any)[queueName];
        (window as any)[queueName] = new (window as any).UET({
          ti: uetTagId,
          enableAutoSpaTracking: true,
          q: queue,
        });
        ((window as any)[queueName] as any).push('pageLoad');
      } catch (err) {
        // ignore tracking failures
      }

      script.onload = null;
      (script as any).onreadystatechange = null;
    };

    script.onload = onLoad;
    (script as any).onreadystatechange = onLoad;

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }, [uetTagId, shouldEnable]);

  useEffect(() => {
    if (!shouldEnable || typeof window === 'undefined') return;

    try {
      const tracker = (window as any).uetq;
      if (tracker && typeof tracker.push === 'function') {
        tracker.push('pageLoad');
      }
    } catch (err) {
      // ignore tracking failures
    }
  }, [location.pathname, location.search, shouldEnable]);

  return null;
};

export default MicrosoftUetTag;
